import React from "react";
import { Monitor, Layers, ChevronRight } from "lucide-react";
import { CONTACT } from "../data/mock";

export function ThreeDSection({ onGetQuote }) {
  return (
    <section id="3d-design" className="py-20 bg-[#1a1a1a]" data-testid="3d-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          {/* Left: Content */}
          <div className="text-white">
            <div className="inline-flex items-center gap-2 bg-[#C9A84C]/20 border border-[#C9A84C]/40 rounded-full px-4 py-1.5 mb-6">
              <Layers size={14} className="text-[#C9A84C]" />
              <span className="text-[#C9A84C] text-xs font-semibold tracking-wider uppercase">3D Design Service</span>
            </div>

            <h2 className="font-serif text-3xl sm:text-4xl font-bold leading-tight mb-6">
              See Your Dream Home
              <span className="block text-[#C9A84C]">Before It's Built</span>
            </h2>

            <p className="text-gray-300 mb-8 leading-relaxed">
              Our advanced 3D visualization technology lets you walk through your future home before a single nail is hammered. 
              Make confident decisions, avoid costly changes, and ensure the final result matches your vision perfectly.
            </p>

            <div className="space-y-4 mb-8">
              {[
                "Photorealistic 3D renders of every room",
                "Virtual walkthroughs of your entire home",
                "Material and color swapping in real-time",
                "Unlimited revisions until you're 100% satisfied",
              ].map((point) => (
                <div key={point} className="flex items-start gap-3">
                  <div className="w-5 h-5 rounded-full bg-[#C9A84C] flex-shrink-0 flex items-center justify-center mt-0.5">
                    <span className="text-white text-xs font-bold">✓</span>
                  </div>
                  <span className="text-gray-300 text-sm">{point}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-wrap gap-4">
              <button
                onClick={onGetQuote}
                className="flex items-center gap-2 bg-[#C9A84C] text-white font-semibold px-7 py-3.5 rounded-full hover:bg-[#b8933e] transition-colors"
                data-testid="3d-get-quote-btn"
              >
                Get 3D Design
                <ChevronRight size={16} />
              </button>
              <a
                href={`https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent("Hi! I want to see 3D designs for my Hyderabad home.")}`}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-2 border border-white/30 text-white font-semibold px-7 py-3.5 rounded-full hover:border-[#C9A84C] hover:text-[#C9A84C] transition-colors"
              >
                <Monitor size={16} />
                See Sample
              </a>
            </div>
          </div>

          {/* Right: 3D Image collage */}
          <div className="relative">
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-3">
                <div className="rounded-xl overflow-hidden aspect-[4/3]">
                  <img
                    src="https://images.unsplash.com/photo-1600494448850-6013c64ba722?w=500&q=80"
                    alt="3D Interior Visualization"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="rounded-xl overflow-hidden aspect-square">
                  <img
                    src="https://images.unsplash.com/photo-1682662046426-f7589013d25e?w=400&q=80"
                    alt="3D Living Room Design"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="space-y-3 pt-6">
                <div className="rounded-xl overflow-hidden aspect-square">
                  <img
                    src="https://images.unsplash.com/photo-1558442074-3c19857bc1dc?w=400&q=80"
                    alt="3D Bedroom Design"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="rounded-xl overflow-hidden aspect-[4/3]">
                  <img
                    src="https://images.unsplash.com/photo-1678762200388-51e11225d4de?w=500&q=80"
                    alt="3D Kitchen Design"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>

            {/* Floating badge */}
            <div className="absolute -bottom-4 left-4 bg-[#C9A84C] text-white rounded-xl p-4 shadow-xl">
              <div className="text-2xl font-bold">100%</div>
              <div className="text-xs font-medium">Match Guaranteed</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
